var _g, _g2, _g3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPresoSlides = function SvgPresoSlides(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 584,
    height: 255,
    fill: "none",
    viewBox: "0 0 584 255"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#preso-slides_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 210.609,
    height: 156.782,
    fill: "#fff",
    rx: 4,
    transform: "rotate(5.179 118.121 3997.321)skewX(-.045)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "#8FC4E8",
    rx: 2,
    transform: "rotate(5.179 -1212.688 5067.841)skewX(-.045)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 30.441,
    height: 6,
    fill: "#F3F4F6",
    rx: 3,
    transform: "rotate(5.179 -1243.796 5265.842)skewX(-.045)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "#A9DED1",
    rx: 2,
    transform: "rotate(5.179 -1013.675 5077)skewX(-.045)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 40.971,
    height: 6,
    fill: "#F3F4F6",
    rx: 3,
    transform: "rotate(5.179 -1044.784 5275)skewX(-.045)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "#A9B4C5",
    rx: 2,
    transform: "rotate(5.179 -814.657 5086.147)skewX(-.045)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 49.396,
    height: 6,
    fill: "#F3F4F6",
    rx: 3,
    transform: "rotate(5.179 -845.768 5284.148)skewX(-.045)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8FC4E8",
    d: "M391.798 88.711a29.5 29.5 0 0 1 10.787-6.766 29.7 29.7 0 0 1 12.66-1.606l-1.039 11.366a18.1 18.1 0 0 0-7.723.98 18 18 0 0 0-6.58 4.127z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A9DED1",
    d: "M389.932 128.21a29.15 29.15 0 0 1-6.805-20.114 29.15 29.15 0 0 1 8.671-19.385l8.105 8.101a17.78 17.78 0 0 0-5.289 11.825 17.77 17.77 0 0 0 4.151 12.27z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A9B4C5",
    d: "M415.245 80.339a29.65 29.65 0 0 1 13.528 4.696 29.4 29.4 0 0 1 9.704 10.47 29.078 29.078 0 0 1 .213 27.59 29.3 29.3 0 0 1-9.54 10.606 29.6 29.6 0 0 1-13.454 4.886 29.7 29.7 0 0 1-14.189-1.987 29.5 29.5 0 0 1-11.575-8.39l8.833-7.303a18 18 0 0 0 7.06 5.118 18.1 18.1 0 0 0 8.656 1.212 18.1 18.1 0 0 0 8.207-2.981 17.9 17.9 0 0 0 5.819-6.469 17.73 17.73 0 0 0-.13-16.831 17.9 17.9 0 0 0-5.919-6.386 18.1 18.1 0 0 0-8.252-2.865z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 81.084,
    height: 8.884,
    fill: "#303747",
    rx: 2,
    transform: "rotate(5.179 -160.85 4404.52)skewX(-.045)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 38.963,
    height: 4.181,
    fill: "#E3E6EA",
    rx: 2,
    transform: "rotate(5.179 -68.397 4408.77)skewX(-.045)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#preso-slides_svg__b)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 210.616,
    height: 156.777,
    fill: "#fff",
    rx: 4,
    transform: "rotate(.79 -2067.361 12973.423)skewX(-.007)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 31.592,
    height: 17.768,
    fill: "#8FC4E8",
    rx: 4,
    transform: "rotate(.79 -10004.238 23028.774)skewX(-.007)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 31.592,
    height: 17.768,
    fill: "#A9DED1",
    rx: 4,
    transform: "rotate(.79 -9980.703 19582.151)skewX(-.007)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 31.592,
    height: 17.768,
    fill: "#A9B4C5",
    rx: 4,
    transform: "rotate(.79 -9956.851 16097.195)skewX(-.007)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 64.871,
    height: 16.813,
    x: 0.986,
    y: 1.014,
    fill: "#F9FAFB",
    stroke: "#D1D5DB",
    strokeWidth: 2,
    rx: 3,
    transform: "rotate(.79 -7006.4 18340.02)skewX(-.007)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D2D6DC",
    d: "m283.852 117.344 1.053.014-.305 21.947-1.052-.014z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 73.716,
    height: 8.361,
    fill: "#303747",
    rx: 2,
    transform: "rotate(.79 -3797.117 15795.407)skewX(-.007)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 42.65,
    height: 4.181,
    fill: "#E3E6EA",
    rx: 2,
    transform: "rotate(.79 -3188.996 15799.642)skewX(-.007)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D1D5DB",
    d: "m238.301 128.738-.007.5 91.295 1.256.007-.5.007-.5-91.295-1.256zm93.267 3.283-.5-.007-.11 7.929.5.006.5.007.11-7.928zm-95.405 6.618.5.007.11-7.928-.5-.007-.5-.007-.11 7.928zm93.433-8.645-.007.5a1.5 1.5 0 0 1 1.479 1.52l.5.007.5.007a2.5 2.5 0 0 0-2.465-2.534zm-91.295-1.256.007-.5a2.5 2.5 0 0 0-2.535 2.466l.5.007.5.007a1.5 1.5 0 0 1 1.521-1.48z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#preso-slides_svg__c)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#preso-slides_svg__d)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 210.611,
    height: 156.781,
    fill: "#fff",
    rx: 4,
    transform: "rotate(-3.22 1545.126 -59.489)skewX(.013)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 113.73,
    height: 8.362,
    fill: "#374151",
    rx: 2,
    transform: "rotate(-3.22 1902.207 -350.835)skewX(.013)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 49.493,
    height: 4.181,
    fill: "#E3E6EA",
    rx: 2,
    transform: "rotate(-3.22 1753.465 -346.619)skewX(.013)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EEF7FC",
    d: "M157.072 121.131a2 2 0 0 1 1.885-2.109l61.96-3.486 5.955 105.844-63.957 3.598z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9FAFB",
    d: "m25.294 146.585 208.67-11.74.112 1.997-208.67 11.74zM26.192 162.56l208.67-11.74.112 1.997-208.67 11.74zM27.092 178.534l208.67-11.74.112 1.997-208.67 11.74zM27.99 194.509l208.67-11.74.112 1.997-208.67 11.74zM28.889 210.484l208.67-11.74.112 1.997-208.67 11.74z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F3F4F6",
    d: "m30.013 230.452 208.67-11.74.112 1.997-208.67 11.74z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 40.395,
    height: 6,
    x: 25.631,
    y: 152.575,
    fill: "#E5E7EB",
    rx: 2,
    transform: "rotate(-3.22 25.63 152.575)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 31.613,
    height: 6,
    x: 106.172,
    y: 148.044,
    fill: "#E5E7EB",
    rx: 2,
    transform: "rotate(-3.22 106.172 148.044)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 31.613,
    height: 6,
    x: 177.798,
    y: 144.015,
    fill: "#D1D5DB",
    rx: 2,
    transform: "rotate(-3.22 177.798 144.015)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 28.979,
    height: 6,
    x: 26.53,
    y: 168.55,
    fill: "#E5E7EB",
    rx: 2,
    transform: "rotate(-3.22 26.53 168.55)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 36.004,
    height: 6,
    x: 27.429,
    y: 184.525,
    fill: "#E5E7EB",
    rx: 2,
    transform: "rotate(-3.22 27.429 184.525)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 46.542,
    height: 6,
    x: 28.327,
    y: 200.5,
    fill: "#E5E7EB",
    rx: 2,
    transform: "rotate(-3.22 28.327 200.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 43.908,
    height: 6,
    x: 29.338,
    y: 218.471,
    fill: "#9CA3AF",
    rx: 2,
    transform: "rotate(-3.22 29.338 218.471)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 40.395,
    height: 6,
    x: 96.394,
    y: 130.566,
    fill: "#9CA3AF",
    rx: 2,
    transform: "rotate(-3.22 96.394 130.566)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 31.613,
    height: 6,
    x: 107.07,
    y: 164.019,
    fill: "#E5E7EB",
    rx: 2,
    transform: "rotate(-3.22 107.07 164.019)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 31.613,
    height: 6,
    x: 107.969,
    y: 179.994,
    fill: "#E5E7EB",
    rx: 2,
    transform: "rotate(-3.22 107.969 179.994)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 31.613,
    height: 6,
    x: 108.868,
    y: 195.969,
    fill: "#E5E7EB",
    rx: 2,
    transform: "rotate(-3.22 108.868 195.969)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 31.613,
    height: 6,
    x: 109.879,
    y: 213.94,
    fill: "#9CA3AF",
    rx: 2,
    transform: "rotate(-3.22 109.879 213.94)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 40.395,
    height: 6,
    x: 24.62,
    y: 134.604,
    fill: "#9CA3AF",
    rx: 2,
    transform: "rotate(-3.22 24.62 134.604)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 40.395,
    height: 6,
    x: 168.02,
    y: 126.536,
    fill: "#6B7280",
    rx: 2,
    transform: "rotate(-3.22 168.02 126.536)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 31.613,
    height: 6,
    x: 178.697,
    y: 159.989,
    fill: "#D1D5DB",
    rx: 2,
    transform: "rotate(-3.22 178.697 159.989)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 31.613,
    height: 6,
    x: 179.596,
    y: 175.964,
    fill: "#D1D5DB",
    rx: 2,
    transform: "rotate(-3.22 179.596 175.964)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 31.613,
    height: 6,
    x: 180.494,
    y: 191.939,
    fill: "#D1D5DB",
    rx: 2,
    transform: "rotate(-3.22 180.494 191.939)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 31.613,
    height: 6,
    x: 181.506,
    y: 209.911,
    fill: "#6B7280",
    rx: 2,
    transform: "rotate(-3.22 181.506 209.911)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "preso-slides_svg__a",
    width: 242.022,
    height: 193.14,
    x: 341.996,
    y: -0.344,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    "in": "SourceAlpha",
    radius: 3,
    result: "effect1_dropShadow_99_20922"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0666667 0 0 0 0 0.0941176 0 0 0 0 0.152941 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_99_20922"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_99_20922",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "preso-slides_svg__b",
    width: 230.771,
    height: 177.657,
    x: 170.996,
    y: 23.656,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    "in": "SourceAlpha",
    radius: 3,
    result: "effect1_dropShadow_99_20922"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0666667 0 0 0 0 0.0941176 0 0 0 0 0.152941 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_99_20922"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_99_20922",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "preso-slides_svg__c",
    width: 237.12,
    height: 186.361,
    x: -0.219,
    y: 68.866,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    "in": "SourceAlpha",
    radius: 3,
    result: "effect1_dropShadow_99_20922"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0666667 0 0 0 0 0.0941176 0 0 0 0 0.152941 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_99_20922"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_99_20922",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "preso-slides_svg__d"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 210.611,
    height: 156.781,
    fill: "#fff",
    rx: 4,
    transform: "rotate(-3.22 1545.126 -59.489)skewX(.013)"
  })))));
};
export default SvgPresoSlides;